/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './DocumentEditor.scss';
import BaseReactComponent from '../../Util/BaseReactComponent';
import { connect } from 'react-redux';
import baseComponent from '../../../decorators/baseComponent';
import reactMixin from 'react-mixin';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { Form, ValidatedInput } from 'react-bootstrap-validation';
import {uploadFile} from '../../../actioncreators/ZehnderActions.js';
import CountryDropDown from '../../Util/CountryDropDown';
import Tabs from 'react-bootstrap/lib/Tabs';
import Tab from 'react-bootstrap/lib/Tab';
import {DropDownMenu, MenuItem} from 'material-ui';
import {isWebUri} from 'valid-url';

@connect(state => ({
    user: state.login.user,
}))
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin) class DocumentEditor extends BaseReactComponent {

    constructor(props) {
        super(props);

        this.state = {};
        this.state.editMode = undefined;
    }

    onAddDocument(d) {
        if (d) {
            let copy = Object.assign(d, {
                editMode: 'NEW',
                modelI: undefined,
                size: undefined,
                data: undefined,
                country: undefined
            });

            this.setState(copy);
        }
    }

    editDocument(d) {
        if (d) {
            let copy = Object.assign(d, {
                editMode: 'EDIT'
            });

            this.setState(copy);
        }
    }



    onDocumentAdd(v) {
        if (this.state.tab === 0 || this.state.tab === undefined) {
          if (isValidURL(this.state.url) ) {
            this.props.addDocument({
              name: v.name,
              description: v.description,
              url: this.state.url,
              size: this.state.size,
              model: this.state.model,
              country: this.state.country
            }, () => {
            });
          } else {
            this.props.dispatch({
              type: 'invalid_url',
              text: this.getIntlMessage('error.documents.invalid-url'),
              level: 'error',
              timeout: 5000
            });
          }
        } else if (this.state.tab === 1) {
            let file = this.refs.file.files[0];
            this.uploadFile(file);
            let name = this.state.data.name.replace(' ', '_');

            let document = {};
            Object.assign(document, this.state);

            document.size = this.state.data.size;
            document.url = '/documents/' + this.state.model + '/' + this.state.country + "/" + name;
            document.name = v.name;
            document.description = v.description;

            this.props.addDocument(document, () => uploadFile('document', this.state.data, name, null, this.state.model, this.state.country)(this.props.dispatch));
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.document() !== undefined && nextProps.document().editMode === 'EDIT') {//|| this.variantsUpdated(nextProps)) {
            this.editDocument(this.props.document());
            this.props.document().editMode = undefined;
        } else if (nextProps.document() !== undefined && nextProps.document().editMode === 'NEW') {
            this.onAddDocument(nextProps.document());
            this.props.document().editMode = undefined;
        }
    }

    cancelEdit() {
        this.props.changeTab(9);
    }

    handleChange(key, event) {
        let update = {};
        update[key] = event.currentTarget.value;
        this.setState(update);
    }

    handleTabsChange(value) {
        this.props.changeTab(value);
    }

    handleSubTabsChange(value) {
        this.setState({
            tab: value
        });
    }

    keyup(e) {
        if (e.which === 13) {
            this.onDocumentAdd(e);
        }
    }

    onChange(type, event) {
        if (type === 'country') {
            this.setState({country: event});
        }
    }

    uploadFile(file) {
        this.state.data = file;

        let reader = new FileReader();
        reader.onload = function () {
            //self.state.data.content = this.result;
        };
        // reader.readAsBinaryString(file);//not working on ie11
        reader.readAsText(file);
    }

    pickedModel(event, modelI) {
        this.setState({
            modelI: modelI,
            model: modelI === 1 ? "EVALVE" : "T400"
        });
    }

    render() {
        let subTitle = this.getMessage(this.state.editMode === 'EDIT' ? 'edit-document' : 'add-document');

        let css = {
            borderTop: "solid 1px #e0e0e0",
            bottom: "1px",
            left: "0",
            margin: "0",
            right: "0",
            position: "absolute"
        };

        let labelcss = {
            lineHeight: 40 + 'px'
        };

        return (
            <div className="DocumentEditor">
                <div className="editor-header">
                    <div className="container">
                        <h1>{subTitle}</h1>
                    </div>
                </div>

                <div className="container">
                    <Form role="form" className="form-horizontal" onKeyPress={this.keyup.bind(this)} onValidSubmit={this.onDocumentAdd.bind(this)}>
                        <div className="form-group">
                            <label htmlFor="name" className="col-sm-2 control-label">{this.getMessage('name-label')}</label>

                            <div className="col-sm-6">
                                <ValidatedInput name="name"
                                                type="text"
                                                className="validate"
                                                id="name"
                                                onChange={this.handleChange.bind(this, 'name')}
                                                value={this.state.name}
                                                validate="required"
                                                errorHelp={{
                                  required: this.getMessage('no-name-entered')
                                }}
                                    />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="description" className="col-sm-2 control-label">{this.getMessage('description-label')}</label>

                            <div className="col-sm-6">
                                <ValidatedInput name="description"
                                                type="text"
                                                className="validate"
                                                id="description"
                                                onChange={this.handleChange.bind(this, 'description')}
                                                value={this.state.description}
                                                validate="required"
                                                errorHelp={{
                                  required: this.getMessage('no-description-entered')
                                }}
                                    />
                            </div>
                        </div>


                        <div className="form-group">
                            <label htmlFor="url" className="col-sm-2 control-label">{this.getMessage('type-label')}</label>

                            <div className="col-sm-6">
                                <Tabs className="col s12 HomePage-tabs-tabs" activeKey={this.state.tab} onSelect={this.handleSubTabsChange.bind(this)}>
                                    <Tab title={this.getMessage('tabs.url-tab')} eventKey={0} className="DocumentEditor-tabs-tab">
                                        <div className="form-group padding-10">
                                            <label htmlFor="url" className="col-sm-2 control-label">{this.getMessage('url-label')}</label>

                                            <div className="col-sm-10">
                                                <input name="url"
                                                       type="text"
                                                       className="validate form-control"
                                                       id="url"
                                                       onChange={this.handleChange.bind(this, 'url')}
                                                       value={this.state.url}/>
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab title={this.getMessage('tabs.upload-tab')} eventKey={1} className="DocumentEditor-tabs-tab">
                                        <div className="form-group card-panel padding-10">

                                            <div className="col-sm-12 form-group">
                                                <div className="FileUpload-input file-field input-field controls">
                                                    <div className="btn btn-primary">
                                                        <input ref="file" type="file" disabled={this.state.tab === 0}/>
                                                        <span>{this.getMessage('choose-file')}</span>
                                                    </div>
                                                    <div className="file-path-wrapper">
                                                        <input className="file-path validate form-control" type="text"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>


                        <div className="form-group">
                            <label htmlFor="country" className="col-sm-2 control-label">{this.getMessage('country-label')}</label>

                            <div className="col-sm-6 no-padding">
                                <CountryDropDown className="validate form-control" id="country" onChange={this.onChange.bind(this)} edit={true} country={this.state.country}/>
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="model" className="col-sm-2 control-label">{this.getMessage('model-label')}</label>

                            <DropDownMenu className="modelDropDown" onChange={this.pickedModel.bind(this)} autoWidth={true} value={this.state.modelI !== undefined ? this.state.modelI : 99} underlineStyle={css} labelStyle={labelcss}>
                                <MenuItem disabled key={99} value={99} primaryText={this.getIntlMessage('homepage.installer-company-editor.pick')}/>
                                <MenuItem key={0} value={1} primaryText="eValve"/>
                                <MenuItem key={1} value={2} primaryText="T400"/>
                            </DropDownMenu>
                        </div>


                        <div className="controls">
                            <button className="btn btn-primary">{this.getMessage('save-button')}</button>
                            <a className="btn btn-link" onClick={this.cancelEdit.bind(this)}>{this.getMessage('cancel-button')}</a>
                        </div>
                    </Form>

                </div>
            </div>
        );
    }
}

function isValidURL(str) {
  return isWebUri(str);
}

DocumentEditor.propTypes = {
    addDocument: React.PropTypes.func
};

DocumentEditor.defaultProps = {
    componentName: 'document-editor'
};

export default DocumentEditor;




// WEBPACK FOOTER //
// /src/components/Document/DocumentEditor/DocumentEditor.js